import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function Ask() {
  const [faqs, setFaqs] = useState([]); const [q, setQ] = useState(""); const [ticket, setTicket] = useState("");
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);
  const filtered = faqs.filter((f) => (f.q + f.a).toLowerCase().includes(q.toLowerCase()));
  const submit = async () => {
    if (!ticket.trim()) return;
    try { await api.post("/ask/ticket", { question: ticket }); toast.success("Sent. We'll come back to you."); setTicket(""); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <div className="space-y-8">
      <div>
        <div className="label-eyebrow">Ask BA30</div>
        <h1 className="wordmark mt-3 text-4xl md:text-5xl uppercase">Answers. Not Noise.</h1>
      </div>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search the FAQs…"
        className="w-full rounded-md border border-input bg-background px-4 py-3" data-testid="faq-search" />
      <div className="divide-y divide-border border-y border-border">
        {filtered.map((f) => (
          <details key={f.id} className="py-4 group" data-testid={`portal-faq-${f.id}`}>
            <summary className="cursor-pointer font-semibold">{f.q}</summary>
            <p className="mt-2 text-sm text-muted-foreground">{f.a}</p>
          </details>
        ))}
      </div>
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="label-eyebrow">Can't Find It? Ask Us.</div>
        <textarea rows={3} value={ticket} onChange={(e) => setTicket(e.target.value)}
          className="mt-3 w-full rounded-md border border-input bg-background px-3 py-2 text-sm" placeholder="Type your question…" data-testid="ask-ticket" />
        <button onClick={submit} className="btn-primary btn-sm mt-3" data-testid="ask-submit">Submit</button>
      </div>
    </div>
  );
}
